import { SARLAFT_DETAIL } from '../../../../../routes/paths';
import { Table } from '../../../../components/general/table';
import { useSarlaftList } from './hook';
import { SarlaftListProps } from './props';

export const SarlaftList = ({ filters }: SarlaftListProps) => {
    const {
        navigate,
        columns,
        rows,
        loading,
        page,
        pageSize,
        paginator,
        total,
    } = useSarlaftList(filters);

    return (
        <Table
            columns={columns}
            rows={rows}
            rowCount={total}
            loading={loading}
            paginationModel={{
                page,
                pageSize,
            }}
            onPaginationModelChange={paginator}
            pageSizeOptions={[2, 10, 20, 50]}
            disableRowSelectionOnClick
            onRowClick={(item) => navigate(`${SARLAFT_DETAIL}/${item.row.id}`)}
        />
    );
};
